<pre id="configJson">
  {{ configJson }}
</pre>
